<template>
  <layout>
    <template v-slot:title>Create Display Rule</template>
    <rule-form @save="savedOrCanceled" @cancel="savedOrCanceled"></rule-form>
  </layout>
</template>
<script>
import RuleForm from "@/components/business-rules/RuleForm.vue";

export default {
  components: { RuleForm },
  methods: {
    savedOrCanceled: function() {
      this.$router.push("/businessrules");
    },
  },
};
</script>
